import { render, staticRenderFns } from "./bag-model-form.vue?vue&type=template&id=37a160dc&scoped=true&lang=pug&"
import script from "./bag-model-form.vue?vue&type=script&lang=ts&"
export * from "./bag-model-form.vue?vue&type=script&lang=ts&"
import style0 from "./bag-model-form.vue?vue&type=style&index=0&id=37a160dc&scoped=true&lang=css&"
import style1 from "./bag-model-form.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a160dc",
  null
  
)

export default component.exports